// extracted by mini-css-extract-plugin
module.exports = {"container":"hero_container__-0VA8","mainText":"hero_mainText__3E7q8","btn":"hero_btn__zr4DS"};